module.exports = __webpack_public_path__ + "static/entreaide2-9c53f40cc361be8bf6575170bf7a2c69.svg";